




































































import { Vue, Component } from 'vue-property-decorator'
import ModalContactUs from '@/components/Modal/ModalContractUs.vue'
import RouteName from '@/utils/RouteName'
import ModalName from '@/utils/ModalName'
import BaseIcon from '@/components/reusable-components/basics/BaseIcon.vue'
import TranslationModule from '@/utils/TranslationModule'

@Component({
    name: 'PrivateFooter',
    components: {
        ModalContactUs,
        BaseIcon,
    },
})
export default class PrivateFooter extends Vue {
    RouteName: typeof RouteName = RouteName
    ModalName: typeof ModalName = ModalName

    partners = {primary:[
        {
            key: 'tikehau',
            src: require('@/assets/images/partners/tikehau_light.svg'),
            href: 'https://www.tikehaucapital.com/fr/',
        },
        {
            key: 'bpi',
            src: require('@/assets/images/partners/bpi_light.svg'),
            href: 'https://www.bpifrance.fr/',
        },
        {
            key: 'bnp',
            src: require('@/assets/images/partners/BNP_WM_light.svg'),
            href: 'https://wealthmanagement.bnpparibas/fr.html'
        },
    ], secondary: [

    {
            key: 'bank_of_montreal',
            src: require('@/assets/images/partners/bank-of-montreal_light.svg'),
            href: 'https://www.bmo.com/principal/particuliers',
        },

    {
            key: 'contentsquare',
            src: require('@/assets/images/partners/contentsquare_light.svg'),
            href: 'https://contentsquare.com/',
        },
        {
            key: 'cooley',
            src: require('@/assets/images/partners/cooley_light.svg'),
            href: 'https://www.cooley.com/',
        },
    ]}
    
    links = [
        { label: this.$trans('trip_planner', TranslationModule.COMMON), href: '/trips/add' },
        { label: this.$trans('footer.our_team', TranslationModule.COMMON), to: { name: RouteName.TEAM_PAGE } },
        {
            label: this.$trans('footer.privacy_policy', TranslationModule.COMMON),
            href: this.$trans('url.privacy_policy', 'common'),
        },
        { label: this.$trans('footer.cgv', TranslationModule.COMMON), href: this.$trans('url.cgv', 'common') },
    ]
}
